import { CUSTOM_ELEMENTS_SCHEMA, NgModule,  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DashboardPageRoutingModule } from './dashboard-routing.module';

import { DashboardPage } from './dashboard.page';
import { LoginComponent } from '../login/login.component';
import { NavigationComponent } from '../shared/components/navigation/navigation.component';
import { StatisticComponent } from './components/statistic/statistic.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { OrderModuleComponent } from './components/order-module/order-module.component';
import { TerminModuleComponent } from './components/termin-module/termin-module.component';
import { ChatListComponent } from './components/chat-list/chat-list.component';
import { MessagesComponent } from './components/messages/messages.component';
import { TimeLogComponent } from './components/time-log/time-log.component';
import { NewsComponent } from './components/news/news.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DashboardPageRoutingModule,
    NgCircleProgressModule.forRoot({
      // // set defaults here
      // radius: 100,
      // outerStrokeWidth: 16,
      // innerStrokeWidth: 8,
      // outerStrokeColor: "#78C000",
      // innerStrokeColor: "#C7E596",
      // animationDuration: 300,
    })
  ],
  declarations: [
    DashboardPage,
    NavigationComponent,
    StatisticComponent,
    OrderModuleComponent,
    TerminModuleComponent,
    ChatListComponent,
    MessagesComponent,
    TimeLogComponent,
    NewsComponent,
  ],
  providers: [],
  exports: [
    NavigationComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardPageModule { }
